import {
  CertificateIcon_default
} from "./chunk-PR47NZ5Z.mjs";
export {
  CertificateIcon_default as default
};
